import { c as _c } from "react/compiler-runtime";
import { postHostedDocumentsMutation } from '@onefootprint/fetch-hosted';
import { useMutation } from '@tanstack/react-query';
const useSubmitDocType = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = postHostedDocumentsMutation();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useMutation(t0);
};
export default useSubmitDocType;